import 'css-chunksrc/client/scenes/planzoneMaterialResourceAddition/materialResourceForm/styles.scss';export default {
  "materialResourceForm": "_materialResourceForm_1jicl_1",
  "row": "_row_1jicl_8",
  "group": "_group_1jicl_19",
  "label": "_label_1jicl_23",
  "input": "_input_1jicl_29",
  "textArea": "_textArea_1jicl_33"
};